import { render, staticRenderFns } from "./datesDescription.vue?vue&type=template&id=6f068a4a&"
import script from "./datesDescription.vue?vue&type=script&lang=ts&"
export * from "./datesDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports